import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect, batch } from "react-redux";
import {
  fetchData,
  search,
  resetPage,
  changeSource,
  navigateNow,
} from "../../_actions/sidebarSliderActions";
import {
  IconsSources,
  ImageSources,
  ProjectsSources,
  VideoSources,
} from "../../_actions/types";
import { debounce } from "lodash";
import {
  FeatureCodes,
  GIPHY_SLIDER_PANEL,
  ICONS_SLIDER_PANEL,
  IMAGES_SLIDER_PANEL,
  MUSIC_SLIDER_PANEL,
  PROJECTS_SLIDER_PANEL,
  VIDEO_SLIDER_PANEL,
} from "../details/constants";
import {
  Text,
  Flex,
  InputGroup,
  InputLeftElement,
  Input,
  InputRightElement,
  Divider,
  Box,
  Menu,
  MenuButton,
  MenuList,
  MenuDivider,
  Icon,
  MenuOptionGroup,
  MenuItemOption,
} from "@chakra-ui/react";
import { fetchStories, resetStories } from "../../_actions/storiesActions";
import { FaAngleDown, FaSearch, FaTimesCircle } from "react-icons/fa";
import { withTranslation } from "react-i18next";
import { isFeatureAvailable } from "../../_utils/common";
import TldrUpgradeSubscriptionModal from "./modals/TldrUpgradeSubscriptionModal";

class SearchForm extends Component {
  constructor(props) {
    super(props);

    this.onInputChange = this.onInputChange.bind(this);
    this.state = {
      searchText: this.props.sidebarSlider.searchText,
      selectedSource:
        this.props.panelType === IMAGES_SLIDER_PANEL
          ? this.props.sidebarSlider.imageSource
          : this.props.panelType === VIDEO_SLIDER_PANEL
          ? this.props.sidebarSlider.videoSource
          : this.props.panelType === ICONS_SLIDER_PANEL
          ? this.props.sidebarSlider.iconsSource
          : this.props.panelType === MUSIC_SLIDER_PANEL
          ? this.props.sidebarSlider.musicSource
          : this.props.panelType === PROJECTS_SLIDER_PANEL
          ? this.props.sidebarSlider.projectsSource
          : this.props.panelType === GIPHY_SLIDER_PANEL
          ? this.props.sidebarSlider.gifSource
          : "",
      showSubscriptionModal: false,
    };
    this.onPopoverClick = this.onPopoverClick.bind(this);
  }

  dropdownView = (source, options) => {
    const { t } = this.props;
    const radioElements = options.map((option, index) => {
      return (
        <MenuItemOption
          key={index}
          value={option}
          py={1}
          _checked={{ color: "brand.primary" }}
        >
          <Text fontSize="sm">{option}</Text>
        </MenuItemOption>
      );
    });

    return (
      <>
        <Menu isLazy>
          <InputRightElement
            position="relative"
            height="full"
            children={
              <Box display="flex" alignItems="center">
                <Divider
                  mr={2}
                  height="24px"
                  alignSelf="center"
                  orientation="vertical"
                  color="white"
                />
                <Text as="div" fontSize="12px" color="gray.100" mr={2}>
                  {source}
                </Text>
                <Icon as={FaAngleDown} color="gray.100" mr={1} />
              </Box>
            }
            flexDirection={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            as={MenuButton}
            bg="none"
            border="none"
            size="sm"
          />

          <MenuList minW="auto" py={1} zIndex="overlay">
            <MenuOptionGroup
              defaultValue={source}
              type="radio"
              title={t("select_source")}
              onChange={this.onPopoverClick}
            >
              <MenuDivider />
              {radioElements}
            </MenuOptionGroup>
          </MenuList>
        </Menu>
      </>
    );
  };

  render() {
    const { searchText, showSubscriptionModal } = this.state;
    const { searchPlaceholder, t } = this.props;
    var { imageSource, videoSource, iconsSource, projectsSource } =
      this.props.sidebarSlider;
    let dropdownView;
    switch (this.props.panelType) {
      case IMAGES_SLIDER_PANEL:
        dropdownView = this.dropdownView(imageSource, [
          ImageSources.UNSPLASH,
          ImageSources.PIXABAY,
          ImageSources.PEXELS,
          ImageSources.SHOPIFY,
          ImageSources.GOOGLE_DRIVE,
          ImageSources.STORYBLOCKS,
        ]);
        break;
      case VIDEO_SLIDER_PANEL:
        dropdownView = this.dropdownView(videoSource, [
          VideoSources.PIXABAY,
          VideoSources.PEXELS,
          VideoSources.STORYBLOCKS,
        ]);
        break;
      case ICONS_SLIDER_PANEL:
        dropdownView = this.dropdownView(iconsSource, [
          IconsSources.NOUN_PROJECT,
          // IconsSources.FLATICON,  // TODO: Temporary disable flaticon support because v3 API is not supported yet
        ]);
        break;
      case PROJECTS_SLIDER_PANEL:
        dropdownView = this.dropdownView(projectsSource, [
          ProjectsSources.ALL_PROJECTS,
          ProjectsSources.MY_PROJECTS,
          ProjectsSources.SHARED_WITH_ME,
        ]);
        break;
      default:
        break;
    }

    return (
      <Flex m="0" maxWidth="700px" justifyContent="center" pr={"1rem"}>
        <InputGroup color="white">
          <InputLeftElement children={<FaSearch />} />
          <Input
            pr={dropdownView ? "28" : "10"}
            placeholder={searchPlaceholder}
            aria-label="Search"
            onChange={this.onInputChange}
            value={searchText}
            autoFocus={true}
          />

          <InputRightElement
            minW={dropdownView ? "135px" : 0}
            mr={!dropdownView ? "3" : 0}
            justifyContent="flex-end"
            children={
              <>
                {searchText !== "" && (
                  <FaTimesCircle onClick={this.clearSearch} />
                )}
                {dropdownView}
              </>
            }
          />
        </InputGroup>

        {showSubscriptionModal ? (
          <TldrUpgradeSubscriptionModal
            show={showSubscriptionModal}
            onHide={() => {
              this.setState({
                showSubscriptionModal: false,
              });
            }}
          />
        ) : null}
      </Flex>
    );
  }

  onPopoverClick(selectedOption) {
    const { panelType, subscription } = this.props;
    if (panelType === IMAGES_SLIDER_PANEL) {
      const premiumImageSources = [ImageSources.STORYBLOCKS];
      const ifa = isFeatureAvailable(subscription, FeatureCodes.PREMIUM_IMAGES);
      if (premiumImageSources.includes(selectedOption) && !ifa) {
        this.setState({
          showSubscriptionModal: true,
        });
        return;
      }
    }
    this.setState(
      {
        selectedSource: selectedOption,
      },
      function () {
        // fetch stories if projects source is changed.
        if (Object.values(ProjectsSources).indexOf(selectedOption) > -1) {
          this.fetchStoriesAccordingToSource(selectedOption);
          return;
        }

        this.startSearch();
      }
    );
  }

  fetchStoriesAccordingToSource = (selectedOption) => {
    batch(() => {
      this.props.resetStories();
      this.props.fetchStories("", "", 1, {
        ...this.props,
        creatorId:
          selectedOption === ProjectsSources.MY_PROJECTS
            ? this.props.authUser?.pk
            : null,
        excludeCreatorId:
          selectedOption === ProjectsSources.SHARED_WITH_ME
            ? this.props.authUser?.pk
            : null,
      });
    });
  };

  startSearch = () => {
    const { searchText, selectedSource } = this.state;
    if (this.props.panelType === PROJECTS_SLIDER_PANEL) {
      this.searchStories();
      return;
    }

    batch(() => {
      // Set page number to 1
      this.props.resetPage(searchText);
      if (selectedSource) {
        this.props.changeSource(selectedSource);
      }
      // Avoid general fetch call only focusing search form input
      if (!searchText) {
        this.props.fetchData(selectedSource, {
          ...this.props,
          page: 1,
          categoryId: this.props.sidebarSlider?.viewAll?.categoryId,
        });
      } else if (searchText.trim() !== "") {
        this.props.search(selectedSource, searchText.trim(), {
          ...this.props,
          searchText,
          page: 1,
          categoryId: this.props.sidebarSlider?.viewAll?.categoryId,
        });
      }
    });
  };

  /*
    Debounced search will receive search events and fires only last
    one after waiting 500 ms
  */
  debouncedSearch = debounce(async () => {
    this.startSearch();
  }, 500);

  onInputChange(event) {
    let searchText = event.target.value; // this is the search text
    this.setState({ searchText }, () => {
      this.debouncedSearch();
    });
  }

  clearSearch = (event) => {
    this.setState({ searchText: "" }, () => {
      this.startSearch();
    });
  };

  searchStories = () => {
    const { searchText } = this.state;

    this.props.resetStories();
    setTimeout(() => {
      this.props.fetchStories("", searchText, this.props.stories.page, {
        ...this.props,
      });
    }, 300);
  };
}

SearchForm.propTypes = {
  panelType: PropTypes.string.isRequired,
  page: PropTypes.number.isRequired,
  resetPage: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired,
  categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  categoryType: PropTypes.string,
};

SearchForm.defaultProps = {
  org: "",
  page: 1,
  creatorId: null,
};

const mapStateToProps = (state) => ({
  page: state.sidebarSlider.page,
  sidebarSlider: state.sidebarSlider,
  panelType: state.sidebarSlider.sliderPanelType,
  story: state.story,
  pagestore: state.pagestore,
  editor: state.editor,
  org: state.auth.payload.selectedOrg,
  auth: state.auth,
  authUser: state.auth?.payload?.user,
  stories: state.stories,
  subscription: state.subscription,
  document: state.document,
});

const mapDispatchToProps = (dispatch) => ({
  resetPage: (payload) => dispatch(resetPage(payload)),
  fetchData: (source, props) => dispatch(fetchData(source, props)),
  search: (source, searchTerm, props) =>
    dispatch(search(source, searchTerm, props)),
  changeSource: (source) => dispatch(changeSource(source)),
  navigateNow: (payload) => navigateNow(payload),
  resetStories: () => dispatch(resetStories()),
  fetchStories: (status, searchPhrase, pageNo, props) =>
    dispatch(fetchStories(status, searchPhrase, pageNo, props)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(["common"])(SearchForm));
